import { Component, Input, OnInit } from '@angular/core';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router'; 
import { HttpClient } from '@angular/common/http';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'atw-text-expire-config',
  templateUrl: './text-expire-config.component.html',
  styleUrls: ['./text-expire-config.component.scss']
})
export class AtwTextExpireConfig implements OnInit {
  @Input() data_tool: any; //nhận data từ ndcDynamicInputs truyền về
  @Input() type_config : string; // xác định trang đang ở page hay preview
  // @Input() id_subproject : any;
  @Input() objectChoosing: any; //nhận data từ ndcDynamicInputs truyền về
  @Input() device: any // xác định trang ở thiết bị desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any;@Input() type: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database

  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  currentViewAll: any = {};
  isCollapsed: boolean = false;
  styles_field = [
    {
      title: 'hieu_ung_chuyen_dong',
      index: 1,
    },
    {
      title: 'Định dạng thời gian',
      index: 2,
    }
  ];

  fonts = [];
  effect_hover = [];
  effect_hover_data: any = {};
  none: boolean = false; // có chọn PHONG CÁCH hay chưa (true=>chưa; false:đã chọn)
  dataAfterChange: any  = {};
  arr_link_page: any;
  id_subproject: any = "";
  link_type: any = [
    {
      name: 'Mở trong trang mới',
      value: '_blank'
    },
    {
      name: 'Mở trong trang hiện tại',
      value: '_self'
    }
  ];

  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private route: ActivatedRoute,
    private router: Router,
    private vhEventMediator: VhEventMediator,
    private http: HttpClient,
  ) {
  }

  ngOnInit(): void {
    
    // phần này get dữ liệu json
    forkJoin([
      this.http.get('assets/fonts/fonts.json'),
      this.http.get('assets/data/effects/text.json'), 
    ]) .subscribe(([fonts, effects]:any)=>{
      this.fonts = fonts;
      this.effect_hover = effects;
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type']);
    })

    // Kiểm tra đã chọn Phong cách hay chưa
    // if(!this.class['text-expire__content']['text-shadow']
    //   && !this.class['text-expire']['background-color']
    //   && this.class['text-expire__content']['-webkit-text-stroke-width'] == 0) {
    //     this.dispatchStyles('');
    // }
  }

  ngOnChanges(): void {

    if (this.effect_hover) {
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type'])
      this.customize = this.effect_hover_data?.data?.find(e => e.id == this.config['animation-selected']?.id)?.customize || [];
    }  
  }

  ngOnDestroy() {
    this.saveDataProperties();
  }

  /**
   * Cập nhật định dạng hiển thị
   */
  handleSetDateFormatStyle() {
    if(this.config?.date.date_type_check) {
      this.config.date['date_format_style'] = '1';
    }
    else {
      this.config.date['date_format_style'] = 'dd-MM-yyyy'
    }
    this.updateConfig();
  }

  /**
   * bắt sk thay đổi loại animation để show ra danh sách animation phù hợp
   */
  changeTypeAnimation(){
    this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type']);
  }

  customize = []
  /**Xử lý chọn hiệu ứng hover.
   * @param effect : trả về hiệu ứng hover được chọn
   * @param event : trả về element được active
   */
  chooseHover(effect) {
    if (this.config['animation-selected'].id != effect.id) {
      this.config['animation-selected'].id = effect.id;
      this.staticdata[this.device + '_animation'] = effect.animation;
    }
    this.customize = effect['customize'];
    

    this.updateObject();
    // 000003 - Gạch chân không có cấu hình chi tiết
    if(this.config['animation-selected'].id != '000000' && this.config['animation-selected'].id != '000003') {
      this.openViewAll(this.styles_field[0]);
    }
    this.vhEventMediator.notifyOnConfigChanged({_id: this.objectChoosing._id});
  }
  
  /**
   * Hàm update object vào database.
   */
  updateObject() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
      .then((bool: any) => {
        
      })
  }

  /**
   * Hàm update class
   */
  updateClass() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
      .then((bool: any) => {
        
      })
  }

  /**
   * Hàm update config
   */
  updateConfig() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
      .then((bool: any) => {
        
      })
  }

  /**
   * Set style changed
   * @param name : tên trường data cần lưu
   * @param value : giá trị data
   */
  updateCss(name,key){
    this.dataAfterChange[name] = {...key}
  }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại. 
   * @param: value
   */
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false
  };


  /**
   * Cập nhật lưu data vào database.
   */
  saveDataProperties() {
    if (Object.keys(this.dataAfterChange).length)
    this.vhQueryAutoWeb.updateObject(this.data_tool._id, this.dataAfterChange)
    .then((bool) => {
      
    }, error => {
      console.error(error)
    })
  }
  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event){
    if(event.width) this.class['text-expire']['width'] = event.width + 'px';
    if(event.height) this.class['text-expire']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({ status: 'update-object-selected-ruler', code: this.objectChoosing._id });
    this.updateClass()
  }
}
